// extracted by mini-css-extract-plugin
export var autoExpand = "_1n-8";
export var container = "_1n-7";
export var containerWidth = "_1n-5";
export var disabled = "_1n-2";
export var error = "_1n-3";
export var fullWidth = "_1n-6";
export var inputWrapper = "_1n-0";
export var small = "_1n-1";
export var textarea = "_1n-4";